var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#A1D2AB",
  d: "M17.862 22.328v-7.82l-8.549 4.967v2.853c0 .435-.168.853-.469 1.165-.3.313-.71.494-1.142.507h11.82c-.44 0-.862-.176-1.174-.49-.311-.313-.486-.739-.486-1.182z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEBE2D",
  d: "M9.355 1.672v7.82l8.514-4.967V1.672c0-.443.174-.869.484-1.182.31-.314.73-.49 1.17-.49H7.701c.438 0 .859.176 1.17.49.31.313.483.739.483 1.182z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#5BCBF5",
  d: "M20.428 3.148l-2.518 1.42v9.94l6.863-3.918c.381-.215.832-.275 1.257-.165.424.11.789.38 1.015.753L21.02.896c.114.185.19.391.222.606.032.215.02.434-.035.645-.056.21-.153.407-.287.579-.134.172-.301.315-.492.422z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#15B9A8",
  d: "M27.025 12.815c.141-.237.21-.51.198-.785.01-.29-.058-.578-.198-.834-.225-.373-.589-.644-1.012-.754-.424-.11-.874-.05-1.254.166l-6.849 3.924v7.8c0 .442.177.867.491 1.18.314.312.74.488 1.185.488h.443l.444-.196.295-.197v-.098l.197-.245 4.78-8.29 1.231-2.06.05-.099z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#89A150",
  d: "M17.91 1.624v2.854l2.558-1.427c.194-.107.364-.251.5-.424.137-.173.236-.371.292-.582.056-.212.068-.432.036-.648-.033-.216-.11-.423-.226-.61-.054-.133-.14-.25-.25-.344-.317-.28-.728-.438-1.154-.443h-.05c-.444 0-.87.17-1.189.472-.318.304-.503.717-.517 1.152z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#F6A7C0",
  d: "M6.782 20.852l2.531-1.42v-9.94l-6.85 3.917c-.383.216-.837.276-1.264.166-.426-.11-.793-.38-1.02-.753l6.007 10.282c-.219-.377-.279-.825-.168-1.246.112-.42.386-.782.764-1.006z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#A79087",
  d: "M9.313 22.376v-2.854L6.741 20.95c-.384.225-.662.588-.775 1.011-.113.423-.052.873.17 1.252l.252.345h.05c.154.145.336.259.535.335.2.076.412.112.626.107h.05c.438-.012.853-.187 1.163-.489.31-.302.489-.708.501-1.134z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#F5843C",
  d: "M2.513 13.426l6.8-3.935V1.672c0-.443-.176-.869-.49-1.182C8.509.176 8.083 0 7.638 0h-.444C7.05.035 6.915.102 6.8.197l-.295.196c-.05.05-.05.05-.05.099l-.197.246h-.05L1.43 9 .197 11.065c-.117.247-.184.514-.197.787.007.296.092.584.246.836.1.198.237.374.405.519.168.144.363.254.574.322.211.07.434.095.655.078.22-.018.436-.08.633-.181z"
});

function SvgLoadingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24,
    fill: "none",
    viewBox: "0 0 28 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading-icon.87e303c4.svg";
export { ForwardRef as ReactComponent };